import React,{useState, useEffect} from "react";
import styles from './BoosterMaskedLeads.module.css'
import EmailMask from "../../Components/EmailMask";
import { maskedBossterMonthWise } from "../../Services/contacts";


interface BoosterMaskedLeadsProps {
    backClick: () => void;
    data: any;
    onClick: () => void;
    ctaText: string;
}


const BoosterMaskedLeads: React.FC<BoosterMaskedLeadsProps> = ({backClick, data, onClick, ctaText }) => {

    const [last30DaysCount, setLast30DaysCount] = useState("");
    
      useEffect(() => {
              const fetchLeadCount = async () => {
                try {
                  const res:any = await maskedBossterMonthWise();
                  if (res?.data?.count) {
                    setLast30DaysCount(res.data.count);
                  }
                } catch (error) {
                  console.error("Error fetching masked booster count", error);
                }
              };
          
              fetchLeadCount();
            }, []);

    console.log("data", data)
    return (
        <div className={styles.parent}>
            <div className={styles.Cd}>
                <div className={styles.CdInfo}>
                    <div className={styles.CdName}>
                        <span className={styles.CdBack} onClick={backClick}></span>
                        <span className={styles.CdNameText}>{data.customer_name}</span>
                    </div>
                    <div className={styles.Cdd}>
                        <div className={`${styles.Cddele} ${styles['phone']}`}>
                            <div className={`${styles.CddeleLabel}`}>Phone number</div>
                            <div className={styles.CddeleData}>{data.contact_no}</div>
                        </div>
                        <div className={`${styles.Cddele} ${styles['email']}`}>
                            <div className={`${styles.CddeleLabel}`}>Email</div>
                            {data.email ? <div className={styles.CddeleData}>{<EmailMask email={data.email} />}</div> : <div style={{marginTop:"0.5rem"}}>N/A</div>}
                        </div>
                        <div className={`${styles.Cddele} ${styles['project']}`}>
                            <div className={`${styles.CddeleLabel}`}>Project</div>
                            <div className={styles.CddeleData}>{data.project || 'NA'}</div>
                        </div>
                        <div className={`${styles.Cddele} ${styles['propertyId']}`}>
                            <div className={`${styles.CddeleLabel}`}>Property ID</div>
                            <div className={styles.CddeleData}>{data.property_id || 'NA'}</div>
                        </div>
                    </div>
                </div>
                <div className={styles.CdContent}>
                    <div className={styles.CdContentAlert}>⚠️ Buyer is interested in your {data.property_id? `property ID -${data.property_id},`:"property,"} but this lead is locked</div>
                    <div className={styles.CdContentSubAlert}>There was <span className={styles.TextSemiBold}>no active booster pack for additional leads</span> when this lead was generated.</div>
                </div>
                <div className={styles.CdAdContent}>
                    <div className={styles.CdAdLead}>What are <span>Additional Leads?</span></div>
                    <div className={styles.CdAdLeadtext}>Additional leads are extra leads received through MagicBricks' promotion of your listings across <span className={styles.TextSemiBold}>Top Channels</span>, over and above your regular package leads.</div>
                    <div className={styles.CdActBlock}>
                        <div className={styles.CdActBlockText}><span className={`${styles.TextSemiBold}`}>To get these {last30DaysCount} locked leads next 30 days. </span> </div>
                        <span className={styles.CdCtaGreen} onClick={onClick}>{ctaText}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BoosterMaskedLeads